<ng-container [ngSwitch]="headerType">
  <!-- Deafult Header -->
  <div
    *ngSwitchCase="'default-header'"
    class="default-header-cnt d-lg-none"
    [class.transparent]="transparentBg"
  >
    <!-- Sidebar Button -->
    @if (isHamburgerMenuVisible) {
      <button
        class="back-btn"
        data-bs-toggle="offcanvas"
        data-bs-target="#menubar"
        aria-controls="offcanvasExample"
      >
        <img src="assets/images/icons/menu-icon.svg" class="Menuicon" alt="Menu icon" />
      </button>
    }
    <!-- Back Button -->
    @if (isBackButtonVisible) {
      <button class="back-btn" (click)="goBack()">
        <img src="assets/images/icons/Back.svg" class="icon" alt="Back icon" />
      </button>
    }
    <h6 class="default-header-tlt">{{ headerTitle }}</h6>
    <div class="d-flex align-items-center justify-content-center" style="height: 44px; width: 50px">
      <button class="back-btn" *ngIf="headerTitle == 'Dashboard'">
        <img
          src="/assets/images/icons/Notification-Icon.svg"
          class="icon"
          alt="Notification icon"
        />
      </button>
    </div>
  </div>

  <!-- Work/Work-Overview Header Web -->
  <div *ngSwitchCase="'web-work-list'" class="d-md-none d-sm-none d-lg-block">
    <div class="tab-toggle">
      <div
        class="slider"
        [ngClass]="{
          'slide-right': activeTab === 'overview',
          'slide-left': activeTab === 'work',
        }"
      ></div>
      <button class="tab" [class.active]="activeTab === 'work'" (click)="onTabClick('work', 'web')">
        Work <span *ngIf="activeTab === 'work'" class="badge">{{ myWorkCount }}</span>
      </button>
      <button
        class="tab"
        [class.active]="activeTab === 'overview'"
        (click)="onTabClick('overview', 'web')"
      >
        Work Overview
        <span *ngIf="activeTab === 'overview'" class="badge">{{ workOverviewCount }}</span>
      </button>
    </div>
  </div>

  <!-- Generic Header: process, summary, complete -->
  <div *ngSwitchCase="'process'" class="header-container work-details-header">
    @if (isBackButtonVisible) {
      <button class="back-btn" (click)="goHome()">
        <img src="assets/images/icons/close.svg" class="icon" alt="Close icon" />
      </button>
    } @else {
      <div class="spacer"></div>
    }
    <span class="header-title">{{ headerTitle }}</span>
    <div class="spacer"></div>
  </div>

  <div *ngSwitchCase="'summary'" class="header-container work-details-header">
    <button class="back-btn" (click)="goHome()">
      <img src="assets/images/icons/close.svg" class="icon" alt="Close icon" />
    </button>
    <span class="header-title">{{ headerTitle }}</span>
    <span class="spacer">{{ processedItemIndex }} of 2</span>
  </div>

  <!-- Complete task header(Mobile) -->
  <div
    *ngSwitchCase="'complete'"
    style="height: 72px"
    class="header-container work-details-header"
  >
    <span class="header-title">{{ headerTitle }}</span>
  </div>

  <!-- Work Reference Header -->
  <div *ngSwitchCase="'work-reference'" class="header-container work-details-header sticky-top">
    <button class="back-btn" (click)="goBack()">
      <img src="assets/images/icons/Back.svg" class="icon" alt="Back icon" />
    </button>
    <span class="header-title">{{ headerTitle }}</span>
    <span class="spacer"></span>
  </div>
</ng-container>
